import type { SendCommand, CommandResult } from './Commands';
import type { Channel } from 'redux-saga';

let commandChannel: Channel<SendCommand>;
let resultChannel: Channel<CommandResult>;

export const getCommandChannel = () => commandChannel;
export const getResultChannel = () => resultChannel;

export const setCommandChannel = (channel: Channel<SendCommand>): void => {
  commandChannel = channel;
};

export const setResultChannel = (channel: Channel<CommandResult>): void => {
  resultChannel = channel;
};
